import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import axios from 'axios';

import { authReady, checkForAccess } from 'rp-navigation';
import * as segmentio from 'rp-analytics';
import { getHorseName } from '../../analyticsPage';

import HorseTrackerButton from './HorseTrackerButton';
import ErrorModal from '../ErrorModal';
import {
    getControls,
    getButtons,
    errorMessages,
    getAjaxUrl,
} from './helpers';

class HorseTracker extends PureComponent {
    constructor(props) {
        super(props);
        this.horseUid = this.props.profile.horseUid;
        this.state = {
            button: 'pending',
            error: null,
        };
        this.buttons = getButtons(this.onTrack, this.onTracked, this.onCancel);
        this.controls = getControls(this.onCancel, this.onUntrack);
    }

    componentDidMount() {
        authReady.then((auth) => {
            if (auth.user.isLoggedIn) {
                axios.get(getAjaxUrl(this.horseUid, 'check'))
                    .then(({ data }) => {
                        const { alertMe } = data.data;

                        if (alertMe) {
                            this.onSuccess('tracked');
                        } else {
                            this.onSuccess('track');
                        }
                    })
                    .catch(() => this.onSuccess('track'));
            } else {
                this.onSuccess('track');
            }
        })
        .catch(() => this.onSuccess('track'));
    }

    onTrack = () => {
        checkForAccess('Subscriptions', true, true, {
            text: "Subscribe to Members' Club and get access to this content and much more",
            r: `${window.location.origin}/horse-tracker`,
            service: 'both',
        })
            .then((access) => {
                if (access) {
                    axios.get(getAjaxUrl(this.horseUid, 'check'))
                        .then(({ data }) => {
                            const { alertMe } = data.data;

                            if (alertMe) {
                                this.onSuccess('active');
                            } else {
                                this.trackHorse();
                            }
                        });
                }
            });
    };

    onUntrack = () => {
        axios.get(getAjaxUrl(this.horseUid, 'untrack'))
            .then(({ data }) => {
                const { data: { result }, error } = data;

                if (error) {
                    this.onError('untrack');
                }

                if (result) {
                    this.onSuccess('track');
                    this.segmentUntrackHorse();
                }
            })
            .catch(() => this.onError('untrack'));
    };

    onSuccess = (buttonKey) => {
        this.setState({ button: buttonKey });
    };

    onError = (errorKey) => {
        this.setState({ error: errorKey });
    };

    onTracked = () => {
        this.onSuccess('active');
    };

    onCancel = () => {
        this.onSuccess('tracked');
    };

    closeErrorModal = () => {
        this.onError(null);
    };

    trackHorse = () => {
        axios.get(getAjaxUrl(this.horseUid, 'track'))
            .then(({ data }) => {
                const { data: { result }, error } = data;

                if (error) {
                    if (error.code === 403) {
                        this.onError('limit');
                    } else {
                        this.onError('track');
                    }
                }

                if (result) {
                    this.onSuccess('tracked');
                    this.segmentTrackHorse();
                }
            })
            .catch(() => this.onError('tracked'));
    };

    segmentTrackHorse = () => {
        segmentio.track('Track Horse', { 'Horse Name': getHorseName() });
    }

    segmentUntrackHorse = () => {
        segmentio.track('Untrack Horse', { 'Horse Name': getHorseName() });
    }

    render() {
        const buttonState = this.state.button;
        const shouldShowControls = buttonState === 'active';
        const shouldShowButton = buttonState !== 'pending';
        const errorMessage = errorMessages[this.state.error];

        return (
            <div className="hp-horseTracker">
                {shouldShowControls ? (
                    <div className="hp-horseTracker__controls">
                        {this.controls.map(button =>
                            <HorseTrackerButton {...button} key={shortid.generate()} />
                        )}
                    </div>
                ) : null}
                {shouldShowButton ? (
                    <HorseTrackerButton {...this.buttons[buttonState]} key={shortid.generate()} />
                ) : null}
                {errorMessage ? (
                    <ErrorModal
                        text={errorMessage}
                        onClose={this.closeErrorModal}
                    >
                        {errorMessage === 'limitError' ?
                            (
                                <span> You&apos;ve reached your limit of 1,000 horses.
                                    To add this horse to your tracker please go
                                    to <a
                                        className="ui-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="/horse-tracker/"
                                    > Horse Tracker </a> and remove some horses.
                                </span>
                            ) : null
                        }
                    </ErrorModal>
                ) : null}
            </div>
        );
    }
}

HorseTracker.propTypes = {
    profile: PropTypes.shape({
        horseUid: PropTypes.number.isRequired,
    }).isRequired,
};

export default HorseTracker;



// WEBPACK FOOTER //
// ./src/js/shared/horseTracker/HorseTracker.jsx